import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';

@Injectable()
export class CanaisServiceService {


  constructor(private http: HttpClient) {
   
   }

  public getCanais(): Observable<any>{
    return this.http.get(urlApi+'/app/channels');
  }

  public setCanal(data: any): Observable<any>{
    return this.http.post(urlApi+'/app/channels', data);
  }

  public getConfigUserChannels(): Observable<any>{
    return this.http.get(urlApi+'/app/user/configuracoes');
  }

  public updateFireChannel(data: any): Observable<any>{
    return this.http.patch(urlApi+'/app/channel/fire', {idCanal: data.idcanal, newFire: data.fire});
  }

  public deleteChannelUser(idCanal: number): Observable<any>{
    return this.http.delete(urlApi+'/app/channels/'+idCanal);
  }

  public getQrCode(data: any): Observable<any>{
    return this.http.post(urlApi +'/app/channels/qrcode', { queueId: data.queueId, apiKey: data.apiKey });
  }
}
